import React, { useEffect, useRef, useState } from "react"
import { Modal } from 'react-bootstrap'
import { httpOk, GET, POST } from 'helpers/api'

// Leaflet'ni CDN'dan bir marta yuklaydi (bepul, kalitsiz)
function loadLeaflet() {
	return new Promise((resolve) => {
		if (window.L) return resolve(window.L)
		if (!document.getElementById('leaflet-css')) {
			const css = document.createElement('link')
			css.id = 'leaflet-css'
			css.rel = 'stylesheet'
			css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'
			document.head.appendChild(css)
		}
		const s = document.createElement('script')
		s.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js'
		s.onload = () => resolve(window.L)
		document.head.appendChild(s)
	})
}

const DEFAULT = { lat: 41.311081, lng: 69.240562 } // Toshkent markazi

function GeofenceModal({ show, onClose }) {
	const mapEl = useRef(null)
	const map = useRef(null)
	const marker = useRef(null)
	const circle = useRef(null)
	const [radius, setRadius] = useState(100)
	const [point, setPoint] = useState(null)

	function place(L, lat, lng) {
		setPoint({ lat, lng })
		if (marker.current) marker.current.setLatLng([lat, lng])
		else marker.current = L.marker([lat, lng], { draggable: true }).addTo(map.current)
			.on('dragend', (e) => {
				const p = e.target.getLatLng()
				setPoint({ lat: p.lat, lng: p.lng })
				circle.current && circle.current.setLatLng(p)
			})
		if (circle.current) circle.current.setLatLng([lat, lng])
		else circle.current = L.circle([lat, lng], { radius, color: '#0d6efd', fillColor: '#0d6efd', fillOpacity: 0.12 }).addTo(map.current)
	}

	async function initMap() {
		const L = await loadLeaflet()
		if (!mapEl.current) return

		// Mavjud joylashuvni olamiz
		const res = await GET('/attendance/geofence')
		let center = DEFAULT
		let r = 100
		if (httpOk(res)) {
			r = res.data.geofence_radius || 100
			setRadius(r)
			if (res.data.work_lat && res.data.work_lng) {
				center = { lat: Number(res.data.work_lat), lng: Number(res.data.work_lng) }
			}
		}

		map.current = L.map(mapEl.current).setView([center.lat, center.lng], 16)
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '© OpenStreetMap', maxZoom: 19,
		}).addTo(map.current)

		if (res.data?.work_lat && res.data?.work_lng) {
			place(L, center.lat, center.lng)
		}

		map.current.on('click', (e) => place(L, e.latlng.lat, e.latlng.lng))
		setTimeout(() => map.current && map.current.invalidateSize(), 200)
	}

	function myLocation() {
		if (!navigator.geolocation) return
		navigator.geolocation.getCurrentPosition((pos) => {
			const { latitude, longitude } = pos.coords
			map.current.setView([latitude, longitude], 17)
			place(window.L, latitude, longitude)
		}, () => { alert('Lokatsiya olinmadi') }, { enableHighAccuracy: true })
	}

	async function save() {
		if (!point) { alert('Xaritada ishxona nuqtasini belgilang'); return }
		const res = await POST('/attendance/geofence', {
			work_lat: point.lat, work_lng: point.lng, geofence_radius: Number(radius),
		}, { loader: true })
		if (httpOk(res)) onClose()
	}

	// Radius o'zgarsa circle yangilanadi
	useEffect(() => {
		if (circle.current) circle.current.setRadius(Number(radius) || 100)
	}, [radius])

	useEffect(() => {
		if (show) {
			setTimeout(initMap, 150)
		} else if (map.current) {
			map.current.remove()
			map.current = null; marker.current = null; circle.current = null
		}
	}, [show]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Modal show={show} animation={false} centered size="lg" backdrop="static" onHide={onClose}>
			<Modal.Header closeButton>
				<Modal.Title>Ishxona joylashuvi</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p className="text-muted small mb-2">
					Xaritada ishxona nuqtasини bosing (yoki markerni suring). Xodimlar shu nuqtadan <b>{radius}m</b> ichida bo'lganда "Keldi" hisoblanadi.
				</p>
				<div className="d-flex gap-2 mb-2 align-items-end">
					<div>
						<label className="small text-muted">Radius (m)</label>
						<input type="number" className="form-control" style={{ width: 120 }} min="20" step="10"
							value={radius} onChange={(e) => setRadius(e.target.value)} />
					</div>
					<button className="btn btn-outline-primary" onClick={myLocation}>
						<i className="uil-location-point me-1"></i>Mening joylashuvim
					</button>
				</div>
				<div ref={mapEl} style={{ height: 380, borderRadius: 8, border: '1px solid #dee2e6' }}></div>
				{point &&
					<div className="small text-muted mt-2">
						Nuqta: {point.lat.toFixed(6)}, {point.lng.toFixed(6)}
					</div>
				}
				<div className="d-flex gap-2 mt-3">
					<button className="btn btn-outline-warning w-100" onClick={onClose}>Bekor</button>
					<button className="btn btn-primary w-100" onClick={save}>Saqlash</button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default GeofenceModal
